export default __webpack_public_path__ + "static/media/Bara_Skrae.febbd0c7.png";